export const formatNumber = (value) => Number(value || 0).toLocaleString('en-US');

export const formatDateTime = (value) => {
  if (!value) return 'never synced';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'never synced';
  return `${date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })} ${date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
};

export const formatDate = (value) => {
  if (!value) return 'Not recorded';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Not recorded' : date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
};

const ordinal = (day) => {
  const mod100 = day % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${day}th`;
  return `${day}${{ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th'}`;
};

export const formatLongDateTime = (value, timeZone = 'America/Los_Angeles') => {
  if (!value) return 'never synced';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'never synced';
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone,
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).formatToParts(date).map((part) => [part.type, part.value]));
  const zone = String(parts.timeZoneName || '').replace(/^P[DS]T$/, 'PT');
  return `${parts.weekday}, ${parts.month} ${ordinal(Number(parts.day))}, ${parts.year}, ${parts.hour}:${parts.minute} ${parts.dayPeriod} ${zone}`.trim();
};
